// @ts-nocheck
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import HeaderListItem from 'flarum/forum/components/HeaderListItem';
import Avatar from 'flarum/common/components/Avatar';
import classList from 'flarum/common/utils/classList';
import TradeModal from './TradeModal';

/**
 * Card shown in the bell when another user opens a trade with the actor.
 * Click → open the TradeModal pre-loaded with that trade id, NOT navigate.
 *
 * Bypasses the parent class's view() so we can render HeaderListItem with
 * a null href — the list item renders as `<button>` instead of `<a>`,
 * which fires `onclick` without trying to follow a URL. Returning a fake
 * href (like '#') from `href()` would still let the parent class render
 * a navigable anchor and we'd lose the modal-open behaviour to a route
 * change.
 */
export default class TradeRequestedNotification extends Notification {
  icon() {
    return 'fas fa-handshake';
  }

  // Required abstract methods — overridden view() below ignores href().
  href() {
    return '';
  }
  content() {
    var _this$attrs$notificat, _this$attrs$notificat2, _fromUser$displayName;
    const fromUser = (_this$attrs$notificat = (_this$attrs$notificat2 = this.attrs.notification).fromUser) == null ? void 0 : _this$attrs$notificat.call(_this$attrs$notificat2);
    const name = (fromUser == null || (_fromUser$displayName = fromUser.displayName) == null ? void 0 : _fromUser$displayName.call(fromUser)) || app.translator.trans('ramon-point-system.forum.notifications.admin_fallback');
    return app.translator.trans('ramon-point-system.forum.notifications.trade_requested', {
      name
    });
  }
  excerpt() {
    return null;
  }
  view() {
    var _notification$fromUse, _notification$created;
    const notification = this.attrs.notification;
    const fromUser = (_notification$fromUse = notification.fromUser) == null ? void 0 : _notification$fromUse.call(notification);
    const data = notification.content() || {};
    const tradeId = Number((data == null ? void 0 : data.tradeId) || 0);
    return m(HeaderListItem, {
      className: classList('Notification', "Notification--".concat(notification.contentType()), [!notification.isRead() && 'unread']),
      avatar: m(Avatar, {
        user: fromUser || null
      }),
      icon: this.icon(),
      content: this.content(),
      excerpt: this.excerpt(),
      datetime: (_notification$created = notification.createdAt) == null ? void 0 : _notification$created.call(notification),
      onclick: e => {
        var _e$preventDefault, _e$stopPropagation;
        (_e$preventDefault = e.preventDefault) == null || _e$preventDefault.call(e);
        (_e$stopPropagation = e.stopPropagation) == null || _e$stopPropagation.call(e);
        if (tradeId > 0) {
          app.modal.show(TradeModal, {
            tradeId
          });
        }
        this.markAsRead();
      }
    });
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/TradeRequestedNotification', TradeRequestedNotification);